





















































import CompanyUserRequired from "../../CompanyRequired";
import {Component, Inject, Prop} from "vue-property-decorator";
import {GuiUserlisting} from "@/modules/models";
import PersonMarker from "@/components/PersonMarker.vue";
import Api from "@/components/users/reports/Api";

@Component({
  components: {
    "at-person-marker": PersonMarker,
  }
})
export default class AddPerson extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop({default: false})
  value!: boolean;

  get open() {
    return this.value;
  }
  set open(v: boolean) {
    if(v != this.value) {
      this.$emit("input", v);
    }
  }

  personList: GuiUserlisting[] = [];

  searchTxt = "";
  pageNum = 1;

  async loadPersonList() {
    this.personList = await this.api.userList(this.searchTxt, this.pageNum);
  }

  personSelected(person: GuiUserlisting) {
    this.$emit("at-person-selected", person);
  }

  created() {
    this.loadPersonList();
  }
}
